export class ToolTipData {
  static getTooltipData(errors?: Object): string {
    if (errors) {
      if (errors === null) {
        return `This field is invalid.`;
      }

      // Standard validation errors
      if (errors['maxlength']) {
        return `This input has a maximum length of ${errors['maxlength'].requiredLength}.`;
      }
      if (errors['minlength']) {
        return `This input has a minimum length of ${errors['minlength'].requiredLength}.`;
      }
      if (errors['pattern']) {
        return `This field is improperly formatted.`;
      }
      if (errors['required']) {
        return `This field is required.`;
      }

      // Custom validator errors
      if (errors['whiteListURL']) {
        return errors['whiteListURL'];
      }
      if (errors['customErrorMessage']) {
        return errors['customErrorMessage'];
      }
      if (errors['cannotContainSpace']) {
        return `This field cannot contain spaces.`;
      }
      if (errors['cannotBeginWithOneDigit']) {
        return `Long codes cannot begin with the digit 1.`;
      }
      if (errors['noProtocol']) {
        return errors['noProtocol'];
      }
      if (errors['negativePatternMatch']) {
        if (errors['negativePatternMatch'].value === "New Message") {
          return `You must give this message a new nickname.`;
        }
        return `This input cannot contain any callouts (@{abc}).`;
      }
      if (errors['toggledButNoValue']) {
        return `This field is required when the toggle is enabled.`;
      }
      if (errors['noTrueValueControls']) {
        return `At least one option must be selected.`;
      }
      if (errors['valueIsNotUnique']) {
        return `This value must be unique.`;
      }
      if (errors['itemsInArrayAreNotUnique']) {
        return `Duplicate values are not allowed.`;
      }
      if (errors['itemIsInExternalArray']) {
        return `This value already exists.`;
      }
      if (errors['htmlNonSpace']) {
        return `This field cannot contain only spaces or HTML tags.`;
      }
      if (errors['urlOrInput']) {
        return `This input must be a URL, e.g. http://example.com, or a dynamic input parameter.`;
      }
      if (errors['phoneNumberOrInput']) {
        return `This input must be a phone number, e.g. (555) 555-5555, or a dynamic input parameter.`;
      }
      if (errors['emailOrInput']) {
        return `This input must be an email address or a dynamic input parameter.`;
      }
      if (errors['invalidPattern']) {
        return `This input is not allowed. Please make sure to enter a valid URL or ${errors['invalidPattern'].pattern} parameter.`;
      }
      if (errors['invalidInputParam']) {
        return errors['invalidInputParam'].incomplete
          ? `The dynamic value is incomplete. Please follow the format @{account_dynamic_value}.`
          : `This field only supports approved dynamic values, e.g. @{account_firstname}. Please check the spelling.`;
      }
      if (errors['invalidAuthLinkParam']) {
        return errors['invalidAuthLinkParam'].incomplete
          ? `The dynamic value is incomplete. Please format it exactly as @{auth-link}.`
          : `This field only supports the @{auth-link} dynamic value.`;
      }
      if (errors['invalidDate']) {
        return `Please enter a valid date.`;
      }
      if (errors['startAfterEnd']) {
        return `Start time must be before end time.`;
      }
      if (errors['nonSpace']) {
        return `This input cannot be all spaces.`;
      }

      // Legacy custom error support
      if (errors['custom']) {
        return errors['custom']['message'];
      }

      // String error messages
      if (typeof errors === 'string') {
        return errors;
      }
    } else {
      return `This field is invalid.`;
    }
  }
}
